import { AppGlobalActions } from '@app/_store/actions/global.actions';
import { UnloadedObjectContainer } from '@core/models/general-types/general-types';
import { InMyPocket } from '@core/models/interfaces/storage-data/in-my-pocket';
import { createFeature, createReducer, on } from '@ngrx/store';
import { DateTime } from 'luxon';

import { PocketActions } from './pocket.actions';

export interface PocketState extends UnloadedObjectContainer<InMyPocket> {
  selectedDate: DateTime;
}

export const initialPocketState: PocketState = {
  selectedDate: DateTime.now(),
  object: null,
};

const pocketReducer = createReducer(
  initialPocketState,
  on(AppGlobalActions.loadAppDataSuccess, (state, { globalState }) =>
    // R37. `...(globalState.inMyPocket ?? {})` produced a new state object even
    // when this container was not part of the response, so a one-container
    // load handed all 23 feature slices a new reference and nothing else.
    globalState.inMyPocket ? { ...state, ...globalState.inMyPocket } : state
  ),
  on(PocketActions.loadPocketSuccess, (state, { pocket }) => ({
    ...state,
    ...pocket,
  })),
  on(PocketActions.setPocketSelectedDate, (state, { selectedDate }) => ({
    ...state,
    selectedDate,
  }))
);

export const pocketFeature = createFeature({
  name: 'pocket',
  reducer: pocketReducer,
  extraSelectors: ({ selectPocketState }) => ({
    selectPocketState,
  }),
});
